import { createSelector } from 'reselect';

import getCurrentUser from './getCurrentUser';

const getIsNewUser = createSelector(getCurrentUser, user => {
  if (user) {
    return user.isNew || !user.firstOrderDate;
  }

  return true; // if user is logged out counts as a new user
});

export default getIsNewUser;
